import { map } from "lodash";
import AppContext from "PFApp/app_context";
import { LoadingDots } from "PFComponents/loading_dots";
import NotFoundComponent from "PFComponents/not_found/not_found";
import { fetchPermissionsGroup } from "PFCore/services/admin/permissions_groups/fetch_permissions_group";
import { fetchPermissionsGroups } from "PFCore/services/admin/permissions_groups/fetch_permissions_groups";
import PermissionsGroupEditPage from "PFModules/admin/permissions_groups/edit/permissions_group_edit_page";
import PropTypes from "prop-types";
import React from "react";
import { withRouter } from "react-router-dom";

const sanitizeForCreate = (permissionsGroup) => ({
  ...permissionsGroup,
  id: null,
  default: false,
  display_as: "",
  name: "",
  custom_types_access_levels: { own_profile: {}, activities: {} },
  cross_group_permissions: {},
  permissions: map(permissionsGroup.permissions, ({ name }) => ({
    name,
    permitted: false
  }))
});

class PermissionsGroupEditController extends React.Component {
  state = {
    permissionsGroup: null,
    permissionsGroups: null
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      match: {
        params: { id }
      }
    } = this.props;

    fetchPermissionsGroups({ perPage: 1000 })
      .then(async ({ entries: permissionsGroups }) => {
        const permissionsGroup = id
          ? await fetchPermissionsGroup(id)
          : sanitizeForCreate(permissionsGroups[0]);

        this.setState({ permissionsGroup, permissionsGroups });
      })
      .catch(() => {
        this.setState({ failed: true });
      });
  }

  static contextType = AppContext;

  render() {
    const {
      store: { currentProfile }
    } = this.context;

    if (this.state.failed) {
      return <NotFoundComponent />;
    }

    if (!this.state.permissionsGroup || !this.state.permissionsGroups) {
      return <LoadingDots circlesEnabled pageViewEnabled />;
    }

    return (
      <PermissionsGroupEditPage
        permissionsGroup={this.state.permissionsGroup}
        permissionsGroups={this.state.permissionsGroups}
        customTypes={currentProfile.custom_types}
      />
    );
  }
}

PermissionsGroupEditController.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  })
};

export default withRouter(PermissionsGroupEditController);
